<div class="resume-container">
    <div class="caro-img-container">
        <div class="caro-img">
            <img src="../../../assets/images/Caro.png" alt="">
        </div>
    </div>
    <div class="row">
        <div class="col m6 offset-m3 card purple darken-4 z-depth-5 info-container" id="pdfTable" #pdfTable>
            <div class="card-content white-text">
                <div class="row">
                    <div class="title-container">
                        <h1>CAROLINA DA SILVA</h1>
                        <h6>FULL STACK DEVELOPER</h6>
                    </div>

                </div>
                <div class="divider"></div>
                <div class="row">
                    <div class="section">
                        <div class="title-section teal lighten-2">
                            Educación
                        </div>
                        <div class="description section">
                            <p>
                                <span class="year">2020</span>
                                - Coding Dojo, Estados Unidos.
                            </p>
                            <p>Full Stack Developer</p>
                            <p>
                                <span class="year">2018</span>
                                - Laboratoria. Santiago, Chile.
                            </p>
                            <p>Front-End Developer</p>
                            <p>
                                <span class="year">2009</span>
                                - Universidad Nacional Experimental de las Artes
                                Caracas, Venezuela.
                            </p>
                            <p>Licenciada en Artes Escénicas</p>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="section">
                        <div class="title-section teal lighten-2">
                            Experiencia Profesional
                        </div>
                        <div class="description section">
                            <main>
                                <div class="experiences">
                                    <h5>GO CLOUD</h5>
                                    <p>
                                        Desarrolladora Junior en software de IA
                                        especialista en Bots, plataforma que
                                        utilizaba react en el front y NodeJs para el
                                        backend, apoyé en varias áreas.
                                    </p>
                                </div>
                                <div class="experiences">
                                    <h5>IMPORT CLUB</h5>
                                    <p>
                                        Desarrolladora Front End,
                                        software hecho con Angular, donde
                                        estuve a cargo de implementar
                                        mejoras en el portal público e interno.
                                    </p>
                                </div>
                                <div class="experiences">
                                    <h5>CLEVER IT</h5>
                                    <p>
                                        Desarrolladora Front End,
                                        actualmente trabajo en la contrucción de un agendador de servicios para
                                        importante retail. Software construido con NextJs, ReactJs y unit testing con
                                        85% de coverage.
                                    </p>
                                </div>
                            </main>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="section">
                        <div class="title-section teal lighten-2">
                            Logros profesionales
                        </div>
                        <div class="description section">
                            <h6>Saturdays AI</h6>
                            <p>Seleccionada para realizar programa de estudios en
                                Inteligencia Artificial.
                            </p>
                        </div>
                        <div class="description section">
                            <img class="trophy" src="../../../assets/images/trophy.svg" alt="">
                            <p>Ganadora de la Beca “Her Global Impact” con Coding Dojo, un Bootcamp de desarrollo
                                Fullstack
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="section">
                        <div class="title-section teal lighten-2">
                            Software
                        </div>
                        <div class="description section contact">
                            <ul>
                                <li>Javascript - Intermedio</li>
                                <li>CSS/SCSS</li>
                                <li>React/NextJS/Gatsby - Avanzado</li>
                                <li>Angular - Intermedio</li>
                                <li>Diseño responsive (Bootstrap, Materialize, Angular Material) - Avanzado</li>
                                <li>Firebase - Intermedio</li>
                                <li>NodeJs/Express/MongoDB - Intermedio</li>
                                <li>Python - Iniciación</li>
                                <li>Java - Iniciación</li>
                                <li>AWS</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="section">
                        <div class="title-section teal lighten-2">
                            Contacto
                        </div>
                        <div class="description section contact">
                            <ul class="contact">
                                <li>
                                    <div class="icon-container">
                                        <i class="material-icons">location_on</i>
                                    </div>
                                    Pedro de Valdivia 6923, Macul
                                </li>
                                <li>
                                    <div class="icon-container">
                                        <img class="wsp-icon" src="../../../assets/images/icons8-whatsapp.svg" alt="">

                                    </div>
                                    <div class="contact-description">
                                        <a href="https://wa.me/56950134332" target="_blank">
                                            +56950134332
                                        </a>

                                    </div>
                                </li>
                                <li>
                                    <div class="icon-container">
                                        <i class="material-icons">alternate_email</i>
                                    </div>
                                    <a href="mailto:caritodasilva@gmail.com">
                                        caritodasilva@gmail.com
                                    </a>
                                </li>
                                <li>
                                    <div class="icon-container">
                                        <img src="../../../assets/images/rostro1.png" alt="">
                                    </div>
                                    <a href="https://www.caritodasilva.work" target="_blank">
                                        www.caritodasilva.work
                                    </a>
                                </li>
                                <li>
                                    <div class="icon-container">
                                        <img class="wsp-icon" src="../../../assets/images/icons8-linkedin.svg" alt="">
                                    </div>
                                    <a href="https://www.linkedin.com/in/carolina-da-silva-hernandez/" target="_blank">
                                        carolina-da-silva-hernandez
                                    </a>
                                </li>
                                <li>
                                    <div class="icon-container">
                                        <img src="../../../assets/images/icons8-github.svg" alt="">
                                    </div>
                                    <a href="https://github.com/CaritoDasilva" target="_blank">
                                        CaritoDasilva
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
    <div class="row">
        <div class="btn-download-container">
            <a href="https://firebasestorage.googleapis.com/v0/b/portafoliocaritodasilva.appspot.com/o/cvCaritoDaSilva.pdf?alt=media&token=412d5300-4913-4465-97d1-5567fc17c904"
                class="title-sectionwaves-effect waves-light btn btn-download">
                DESCARGAR PDF
            </a>

        </div>
    </div>
</div>